import { ColorPalette } from '@wordpress/block-editor';
import { PanelBody, ToggleControl, HorizontalRule, RangeControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

export const BottomShapePanel = ({ attributes, setAttributes }) => {
    const { showBottomShape, bottomShapeWidth, bottomShapeHeight, bottomFlipX, bottomFlipY, bottomShapeColor } = attributes;
    
    return (
        <PanelBody title={__('Bottom Shape', 'fse-blocks')}>
            <div className="top-shape-psettings">
                <ToggleControl
                    label={__('Show Bottom Shape', 'fse-blocks')}
                    help={
                        showBottomShape
                            ? __('Bottom shape is visible.', 'fse-blocks')
                            : __('Bottom shape is hidden.', 'fse-blocks')
                    }
                    checked={showBottomShape}
                    
                    onChange={(NewValue)=>{setAttributes({showBottomShape:NewValue})}}
                />
                {showBottomShape && 
                <>
                <HorizontalRule />
                <RangeControl 
                    min={100} max={300} value={bottomShapeWidth || 100} onChange={(newValue)=>{setAttributes({bottomShapeWidth:parseInt(newValue)})}} label={__('Width', 'fse-blocks')} />
                <RangeControl 
                    min={0} max={200} value={bottomShapeHeight} onChange={(newValue)=>{setAttributes({bottomShapeHeight:parseInt(newValue)})}} label={__('Height', 'fse-blocks')} />
                <HorizontalRule />
               <ToggleControl
                    label={__('Flip Horizontal', 'fse-blocks')}
                    checked={bottomFlipX}
                    onChange={(NewValue)=>{setAttributes({bottomFlipX:NewValue})}}
                />
                <ToggleControl
                    label={__('Flip Vertical', 'fse-blocks')}
                    checked={bottomFlipY}
                    onChange={(NewValue)=>{setAttributes({bottomFlipY:NewValue})}}
                />
                <HorizontalRule />
                <div>
                    <label>{__('Bottom Shape Color', 'fse-blocks')}</label>
                    <ColorPalette
                        value={bottomShapeColor}
                        onChange={(NewValue)=>{setAttributes({bottomShapeColor:NewValue})}}
                    />
                </div>

                </>
                }
            </div>
        </PanelBody>
    );
};

 export default BottomShapePanel;